import React from 'react';
import { useTranslation } from '@lt/localization';

import styles from './searchParamsControl.module.css';

const SearchParamsControl = (props) => {
  const { children, innerProps, innerRef, isMobile = false } = props;
  const { t } = useTranslation();
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div className={styles.button} ref={innerRef} {...innerProps} {...props}>
      {isMobile ? t('checkout.search.change') : children}
    </div>
  );
};

export default SearchParamsControl;
